
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import LeakDetection from './components/LeakDetection';
import StormDamage from './components/StormDamage';
import FreeInspections from './components/FreeInspections';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingCallButton from './components/FloatingCallButton';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <LeakDetection />
      <StormDamage />
      <FreeInspections />
      <Testimonials />
      <Contact />
      <Footer />
      <FloatingCallButton />
    </div>
  );
}
